import React, { Component } from 'react';
import { connect } from 'react-redux';
import pick from 'lodash/pick';
import get from 'lodash/get';
import { Link } from 'react-router';
import { AdvertiserApi } from '../../../api';
import { ContentHolder } from '../../../components/common';
import SettingsForm from '../../../components/advertisers/settings/SettingsForm';

class Edit extends Component {

  componentWillMount() {
    this.fetchResource();
  }

  fetchResource(params = {}) {
    const { dispatch } = this.props;
    dispatch(AdvertiserApi.actions.me.get(params));
  }

  render() {
    const { isLoading, advertiser } = this.props;

    return (
      <div className='wrapper wrapper-content'>
        <div className='ibox'>
          <div className='ibox-title'>
            <h5>User Settings</h5>      
          </div>
          <div className='ibox-content'>
            <ContentHolder loading={isLoading}>
              <SettingsForm advertiser={advertiser} />
            </ContentHolder>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { advertiser: { me } } = state;
  const isLoading = me.loading;
  const advertiser = get(me, 'data.data', {});
  
  return { isLoading, advertiser };
};

export default connect(mapStateToProps)(Edit);
